import React from "react";
import Alert from "@mui/material/Alert";

export default function AlertMessage({ message }) {
  return <Alert severity="warning">{message}</Alert>;
}
